<template>
    <div class="vue-youtube-wrapper col-lg-6">
        <template v-if="hasYoutubeVideoId">
            <div class="inner">

                <template v-if="showThumbnail === true">
                    <slot></slot>
                </template>

                <youtube :video-id="youtubeVideoId" ref="youtube"></youtube>

                <button class="play-button" @click="handlePlayClick" :class="showThumbnail ? '' : 'hide'">
                    Speel af
                </button>

            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "YoutubeWrapper",

    props: ['iframeSrc'],

    data() {
        return {
            showThumbnail: true
        }
    },

    computed: {
        youtubeVideoId() {
            let url = this.iframeSrc.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

            if (! _.isNil(url[2])) {
                return url[2].split(/[^0-9a-z_\-]/i)[0];
            }

            return '';
        },

        hasYoutubeVideoId() {
            return ! _.isEmpty(this.youtubeVideoId);
        },

        player() {
            return this.$refs.youtube.player
        }
    },

    methods: {
        handlePlayClick() {
            this.showThumbnail = false;

            this.player.playVideo();
        }
    }
}
</script>